function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { SvgIconEl } from "common/components/svg-icon";
import { getIconForPropertyType } from "common/report/util/properties";
import { CommonDataTableFields } from "common/components/data-table/types";
import { CheckboxEl } from "common/components/checkbox";
import { SortBy, SortOrder } from "common/types/reports/bookmark";
import { PropertyType } from "common/report/constants";
import { TooltipEl } from "common/components/tooltip";
import { FLAT_SORTING_TOOLTIP, GROUPED_SORTING_TOOLTIP, SORTING_TOOLTIP } from "./constants";
export function template() {
  const {
    sortConfig
  } = this.params;
  const {
    t
  } = this.getContext("i18n");
  const {
    segmentColumns,
    dataColumns
  } = this.getSegmentAndDataColumns();
  let dropdownContent;
  if (Boolean(segmentColumns) === false || (segmentColumns === null || segmentColumns === void 0 ? void 0 : segmentColumns.length) === 0) {
    return null;
  }
  if (this.params.isLoading) {
    dropdownContent = /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-loading" }, /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" }), /* @__PURE__ */ jsx("div", { sel: ".mp-skeleton-large" })));
  } else {
    let sortEntries;
    if (sortConfig.sortBy === SortBy.Column) {
      sortEntries = segmentColumns === null || segmentColumns === void 0 ? void 0 : segmentColumns.map((column) => {
        const segmentIndex = parseInt(column.field.slice(CommonDataTableFields.SegmentPrefix.length));
        return /* @__PURE__ */ jsx(SegmentSortEntry, { segmentIndex: parseInt(column.field.slice(CommonDataTableFields.SegmentPrefix.length)), column, dataColumns, columnSortConfig: this.params.sortConfig.colSortAttrs[segmentIndex], handleColumnSortChange: (index, sort) => this.handleColumnSortChange(index, sort) });
      });
    } else if (sortConfig.sortBy === SortBy.Value) {
      sortEntries = /* @__PURE__ */ jsx(ValueSortEntry, { segmentColumns, dataColumns, sortConfig: {
        sortOrder: sortConfig.sortOrder,
        sortBy: SortBy.Value,
        valueField: sortConfig.valueField
      }, handleValueSortChange: (sort) => this.handleValueSortChange(sort) });
    }
    const isGroupedSorting = this.params.sortConfig.sortBy === SortBy.Column;
    const groupEl = (segmentColumns === null || segmentColumns === void 0 ? void 0 : segmentColumns.length) > 1 && /* @__PURE__ */ jsx(CheckboxEl, { attrs: {
      checked: isGroupedSorting
    }, on: {
      click: () => this.handleColumnSortingToggle()
    } }, t("reports.sorting.group-segments"), /* @__PURE__ */ jsx(TooltipEl, { params: isGroupedSorting ? GROUPED_SORTING_TOOLTIP : FLAT_SORTING_TOOLTIP }));
    dropdownContent = /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-entries" }, sortEntries), /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-footer" }, groupEl, /* @__PURE__ */ jsx(ButtonEl, { sel: ".data-sort-menu-reset-button", attrs: {
      disabled: this.isUsingDefaultSort(),
      elref: "resetButton",
      theme: ButtonTheme.Tertiary
    }, on: {
      click: () => this.handleResetClick()
    } }, t("common.reset"))));
  }
  return /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    icon: {
      leftIcon: "sort"
    },
    label: t("reports.sorting.menu-button"),
    "menu-height": 0,
    "menu-width": 500
  }, params: {
    tooltip: SORTING_TOOLTIP
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-content", attrs: {
    slot: "body"
  } }, dropdownContent)));
}
function ValueSortEntry(_ref) {
  let {
    dataColumns,
    segmentColumns,
    sortConfig,
    handleValueSortChange
  } = _ref;
  const metricSortItems = dataColumns === null || dataColumns === void 0 ? void 0 : dataColumns.map((column) => {
    var _column$sortSelectTit;
    return {
      label: (_column$sortSelectTit = column.sortSelectTitle) !== null && _column$sortSelectTit !== void 0 ? _column$sortSelectTit : column.title,
      isSelected: sortConfig.valueField === column.field,
      value: {
        sortOrder: sortConfig.sortOrder,
        sortBy: SortBy.Value,
        valueField: column.field
      }
    };
  });
  metricSortItems.push(...segmentColumns.map((column) => ({
    label: column.title,
    isSelected: sortConfig.valueField === column.field,
    value: {
      sortOrder: sortConfig.sortOrder,
      sortBy: SortBy.Label,
      valueField: column.field
    }
  })));
  let sortIconOverride = null;
  const selectedSegmentColumn = segmentColumns.find((column) => column.field === sortConfig.valueField);
  if (selectedSegmentColumn) {
    sortIconOverride = selectedSegmentColumn.contentType === PropertyType.String ? "alpha" : "value";
  }
  return /* @__PURE__ */ jsx(SortEntry, { key: "value-sort", items: metricSortItems, sortConfig, onChange: (sort) => handleValueSortChange(sort), sortIconOverride, "data-sentry-element": "SortEntry", "data-sentry-component": "ValueSortEntry", "data-sentry-source-file": "template.tsx" });
}
function SegmentSortEntry(_ref2) {
  var _column$sortSelectTit2;
  let {
    segmentIndex,
    column,
    dataColumns,
    columnSortConfig,
    handleColumnSortChange
  } = _ref2;
  const sortOrder = columnSortConfig.sortOrder;
  const metricSortItems = dataColumns === null || dataColumns === void 0 ? void 0 : dataColumns.map((sortColumn) => {
    var _sortColumn$sortSelec;
    return {
      label: (_sortColumn$sortSelec = sortColumn.sortSelectTitle) !== null && _sortColumn$sortSelec !== void 0 ? _sortColumn$sortSelec : sortColumn.title,
      isSelected: columnSortConfig.sortBy === SortBy.Value && columnSortConfig.valueField === sortColumn.field,
      value: {
        sortOrder,
        sortBy: SortBy.Value,
        valueField: sortColumn.field
      }
    };
  });
  let labelSortItem = "alphabetical";
  if (column.contentType === PropertyType.Number) {
    labelSortItem = "range";
  } else if (column.contentType === PropertyType.Datetime) {
    labelSortItem = "date";
  }
  const labelSortOption = {
    label: labelSortItem,
    isSelected: columnSortConfig.sortBy === SortBy.Label,
    value: {
      sortOrder,
      sortBy: SortBy.Label
    }
  };
  const sortOptionItems = [...metricSortItems, labelSortOption];
  return /* @__PURE__ */ jsx(SortEntry, { key: "segment-".concat(segmentIndex), items: sortOptionItems, sortConfig: columnSortConfig, onChange: (sort) => handleColumnSortChange(segmentIndex, sort), sortIconOverride: column.contentType === PropertyType.String ? "alpha" : "value", "data-sentry-element": "SortEntry", "data-sentry-component": "SegmentSortEntry", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: getIconForPropertyType(column.contentType)
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-select-label" }, (_column$sortSelectTit2 = column.sortSelectTitle) !== null && _column$sortSelectTit2 !== void 0 ? _column$sortSelectTit2 : column.title));
}
function SortEntry(_ref3, children) {
  let {
    key,
    items,
    sortConfig,
    onChange,
    sortIconOverride
  } = _ref3;
  const sortOrderIconType = sortConfig.sortBy === SortBy.Label ? sortIconOverride !== null && sortIconOverride !== void 0 ? sortIconOverride : "alpha" : "value";
  const sortOrderIcon = "sort-".concat(sortOrderIconType, "-").concat(sortConfig.sortOrder === SortOrder.Ascending ? "asc" : "desc");
  return /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-entry", key, "data-sentry-component": "SortEntry", "data-sentry-source-file": "template.tsx" }, children, /* @__PURE__ */ jsx("div", { sel: ".data-sort-menu-select" }, /* @__PURE__ */ jsx(SelectEl, { attrs: {
    "always-show-caret": true,
    theme: SelectTheme.Tertiary
  }, props: {
    sections: [{
      items
    }]
  }, on: {
    change: (ev) => onChange(ev.detail.item.value)
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(ButtonEl, { attrs: {
    icon: sortOrderIcon,
    theme: ButtonTheme.Tertiary
  }, on: {
    click: () => {
      const newSortOrder = sortConfig.sortOrder === SortOrder.Ascending ? SortOrder.Descending : SortOrder.Ascending;
      onChange(_objectSpread(_objectSpread({}, sortConfig), {}, {
        sortOrder: newSortOrder
      }));
    }
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" })));
}
